module.exports = __webpack_public_path__ + "img/max-file-approve--pdf.df885148.svg";